/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { createContext, useContext } from 'react';

type SearchTriggerInputContextType = {
	/**
	 * Value of the input element
	 */
	value: string;
	/**
	 * Function to update the value of the input element
	 */
	onChange?: (value: string) => void;
	/**
	 * Whether the input element is at rest
	 */
	isAtRest: boolean;
	/**
	 * Whether the input element is expanded
	 */
	isExpanded: boolean;
	/**
	 * Whether the input element is focused
	 */
	isFocused: boolean;
	/**
	 * Whether the input element is hovered
	 */
	isHovered: boolean;
	/**
	 * Function to set the focused state of the input element
	 */
	setIsFocused: (isFocused: boolean) => void;
	/**
	 * Function to set the hovered state of the input element
	 */
	setIsHovered: (isHovered: boolean) => void;
	/**
	 * Whether the input element should be interactive (hover/interaction styling effects)
	 */
	interactive: boolean;
};

export const SearchTriggerInputContext = createContext<SearchTriggerInputContextType | null>(null);

export const useSearchTriggerInput = () => {
	const context = useContext(SearchTriggerInputContext);
	if (!context) {
		throw new Error('useSearchTriggerInput must be used within a SearchTriggerInputProvider');
	}
	return context;
};
